import type { LedgerTransactionType } from "@a7y/types";

export const PLAN_OPTIONS: { value: string; label: string }[] = [
  { value: "", label: "None (use subscription plan)" },
  { value: "free", label: "Free" },
  { value: "basic", label: "Basic" },
  { value: "pro", label: "Pro" },
  { value: "elite", label: "Elite" },
  { value: "enterprise", label: "Enterprise" },
];

export const PLAN_COLORS: Record<string, string> = {
  free: "zinc",
  basic: "purple",
  pro: "blue",
  elite: "indigo",
  enterprise: "amber",
};

export const STATUS_COLORS: Record<string, string> = {
  active: "green",
  trialing: "blue",
  past_due: "amber",
  grace_overage: "amber",
  canceled: "red",
  sandbox: "zinc",
};

// A7Y-5057: owner / manager / standard (the API reads pre-rename names as these).
export const ROLE_COLORS: Record<string, string> = {
  owner: "purple",
  manager: "blue",
  standard: "zinc",
};

export const TX_TYPE_LABELS: Record<LedgerTransactionType, string> = {
  checkout_completed: "Checkout Completed",
  subscription_updated: "Subscription Updated",
  subscription_canceled: "Subscription Canceled",
  project_activated: "Project Activated",
  project_archived: "Project Archived",
  manual_adjustment: "Manual Adjustment",
  webhook_sync: "Webhook Sync",
  trial_started: "Trial Started",
  trial_expired: "Trial Expired",
  grace_started: "Grace Period Started",
  grace_expired: "Grace Period Expired",
  payment_succeeded: "Payment Succeeded",
  payment_failed: "Payment Failed",
  refund_issued: "Refund Issued",
  tier_migration_2026: "Tier migration (2026)",
  downgrade_scheduled: "Downgrade scheduled",
  downgrade_schedule_canceled: "Scheduled downgrade canceled",
};

export const PROJECT_STATUS_COLORS: Record<string, string> = {
  active: "green",
  archived: "zinc",
  suspended: "amber",
  deleted: "red",
};
